import React from 'react'
import classNames from 'classnames'
import { Field, getIn } from 'formik'
import { FormGroup } from '@peracto/peracto-ui'
import { string } from 'prop-types'
import * as S from './styled'

const TimeField = ({ name, label, showWhen, className, help, ...props }) => (
    <Field name={name}>
        {({ field, form }) => {
            let error = getIn(form.errors, name)

            if (showWhen) {
                const showField = form.values.hasOwnProperty(showWhen)
                    ? form.values[showWhen]
                    : false

                if (!showField) {
                    return null
                }
            }

            props.className = classNames('form-control', className)

            if (help) {
                props['aria-describedby'] = `${name}Help`
            }

            if (!field.value) field.value = '' // Prevent uncontrolled input error

            return (
                <FormGroup {...{ name, label, help }} error={error}>
                    <S.TimeInput
                        type="time"
                        {...field}
                        {...props}
                        disabled={form.isSubmitting || props.disabled}
                    />
                </FormGroup>
            )
        }}
    </Field>
)

export default TimeField

TimeField.propTypes = {
    label: string.isRequired,
    name: string.isRequired,
    className: string,
}
